import { useEffect, useRef, useState } from "react";
import "./DashSelect.css";

/**
 * props:
 *  value      – current value (string)
 *  onChange   – fn(value)
 *  options    – [{ value, label }]
 *  icon       – optional JSX (SVG)
 *  placeholder– shown when no option selected
 */
export default function DashSelect({ value, onChange, options = [], icon, placeholder = "اختر..." }) {
  const [open, setOpen] = useState(false);
  const ref  = useRef(null);

  const selected = options.find((o) => String(o.value) === String(value));
  const label    = selected ? selected.label : placeholder;

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const pick = (val) => {
    onChange(val);
    setOpen(false);
  };

  return (
    <div className={`ds-wrap${open ? " ds-open" : ""}`} ref={ref}>
      <button
        type="button"
        className="ds-trigger"
        onClick={() => setOpen((p) => !p)}
      >
        {icon && <span className="ds-icon">{icon}</span>}
        <span className="ds-label">{label}</span>
        <svg className="ds-chevron" width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </button>

      {open && (
        <ul className="ds-menu" role="listbox">
          {options.map((opt) => (
            <li
              key={opt.value}
              role="option"
              aria-selected={String(opt.value) === String(value)}
              className={`ds-option${String(opt.value) === String(value) ? " ds-selected" : ""}`}
              onClick={() => pick(opt.value)}
            >
              {String(opt.value) === String(value) && (
                <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24" className="ds-check">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
              )}
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
